export default __webpack_public_path__ + "static/headerImage-a0bcad177ecc5222c9be5921dbc9c459.webp";